import { useMutation } from '@tanstack/react-query';

import { toast } from '@/components/ui/use-toast';
// TODO: domainがRouteの依存を持つのは避けたい。domain内部でkeyを管理するようにする
import { appIntegrationKey } from '@/features/app-integration/query/key';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError, handleApiError } from '@/lib/api/error';
import { useTranslation } from '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';

type Options = {
  appIntegrationId: string;
  appUserId: string;
  onSuccess?: () => void;
  onError?: (message: string) => void;
};
/**
 * App UserをReactivate(再発行)するためのカスタムフック
 */
export default function useAppUserReactivate(options: Options) {
  const { i18n } = useTranslation();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const res = await apiClient.POST(
        '/v3/app-integrations/{id}/users/{appUserId}/reactivate',
        {
          params: {
            path: {
              id: options.appIntegrationId,
              appUserId: options.appUserId,
            },
          },
        },
      );
      return getDataOrThrowApiError(res);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: appIntegrationKey.all(options.appIntegrationId),
      });
      toast({ title: 'Success!!' });
      options.onSuccess?.();
    },
    onError: (error) => {
      const { message } = handleApiError(error, {
        language: i18n.language,
      });
      toast({ title: message });
    },
  });
  return { mutate, isLoading: isPending };
}
